/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerWink2Icon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdklEQVR4nN2Vu0oDURCGU3gpVHwCGxGDL6CdWwWCZi4I48yKjRZ5BTEWsdTWSgQbyygkj6DPoVhaRUErESVyciHLbrLZzabRA9OcM/N/M3Nuudy/GkS6hKx3wPaBbK001onROqLkh4oD2WtaYYyYvjmtCMBlnl3cOkZWiwCCbQHSn4xVvA+oICCOkgeQFSC9BtKvcSAjALbRm9/e2VsG1tuYzT0uFPbngLSSCNC1TyJ/q7cmIovDACIy345HXEgMYPbXe/PMuopkjaEVkFYcBFlPkleAu5vMuoZsN0D2PdE9iB45vS8Wi7NhfzcHbA/ZAWzPnudNhf3L5fK0W5sEoAWsl0GIEwfSq5h9aaYCYMcekfXCGZA99VtojRL7njuqEdGUgNaATI9iRTMByBouTkRmkPUcSF8C64eZASX2vW7cWaiq04EVpP0DpHuDQ5lXY1qk9XEuEiYRbzui5N1nMSagmvzLJKu593zE6Wn2E9s9SCT+Z8cvGAh80bglpPAAAAAASUVORK5CYII=)
 */
export const StickerWink2Icon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 2h12a4 4 0 0 1 4 4v7.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v2.5a.5.5 0 0 1-.5.5H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm11.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-2.14 1.99c.15-.53-.3-.99-.86-.99h-5c-.55 0-1.01.46-.86.99a3.5 3.5 0 0 0 6.72 0ZM6.45 6.1a1 1 0 1 0-.9 1.78l1.21.61-1.2.6a1 1 0 1 0 .89 1.8l3-1.5a1 1 0 0 0 0-1.8l-3-1.5Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 16c.03 0 .05.03.04.06a3 3 0 0 1-.58.82l-4.24 4.24a3 3 0 0 1-.82.58.04.04 0 0 1-.06-.04V19a3 3 0 0 1 3-3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
